import React, { FC, useEffect, useState, useContext } from 'react';
import { StyledFindBtn } from './findBtn.styles';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { SearchHandlerForUXLCAll, updateRecentSearched, formFindHotelsQuery } from '../../../utils/Helpers';
import { renderedData } from '../../SearchFormComponent';
import clsx from 'clsx';
import { checkIfGeographicSearchEnabled } from '../../../../../../modules/utils';
import { useConditionalPageContextSERP } from '../../../../../../hooks';
import {
  ContentContext,
  FocusContext,
  SelectDestinationNameContext,
  SuggestedPlaceDetailsContext,
  FormValuesContext,
} from '../../index.contexts';
import { useConditionalSearchFormRenderedDataSERP } from '../../../../../../hooks/lib/useConditionalRenderedData';
import {
  isConcurFlowActive,
  extractConcurCode,
  setConcurUserOverride,
  getSearchFormClickTrackingLoc,
} from '../../../../../../modules/utils/searchFormHelper';
import { useClientEnvVarsStore, useUserDetailsGlobalStore } from '@marriott/mi-store-utils';
import { FLAG_TYPE } from '@marriott/mi-feature-flag-utils';

declare module 'react' {
  interface HTMLAttributes<T> {
    // extends React's HTMLAttributes
    custom_click_track_value?: string;
  }
}

const FindBtn: FC<{
  isPublishUserSelection?: boolean;
  isSearchPage?: boolean;
  sessionToken?: string;
  // eslint-disable-next-line
  searchFormRef: any;
  tabIndex?: number;
  isADFPage?: boolean;
}> = ({ isPublishUserSelection = false, isSearchPage = false, searchFormRef, isADFPage = false }) => {
  const { findHotelLabel, isItForOffersPage, flexibleTabText, localDateFormat } = useContext(ContentContext);
  const { formValues } = useContext(FormValuesContext);
  const { isAutoSuggestSelected, isRecentSearchSelected } = useContext(SelectDestinationNameContext);
  const { tabSelected, nightCount } = useConditionalSearchFormRenderedDataSERP(renderedData);
  const { setIsUserInteractWithComp, setIsUserEditSearchForm, setIsUpdateSearchClicked } = useContext(FocusContext);
  const { suggestedPlaceDetailsCallDone } = useContext(SuggestedPlaceDetailsContext);
  const { envVarsObject } = useClientEnvVarsStore();
  const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, FLAG_TYPE> | undefined;

  const { NEXT_PUBLIC_PRE_PROCESSING_URL, interceptorResponse, preHeader, featureFlagSerpEnableGeographicSearch } =
    useConditionalPageContextSERP();
  const [clicked, setClicked] = useState(false);
  const userDetailsState = useUserDetailsGlobalStore();
  // const eventDispatch = (): void => {
  //   eventUtil.dispatch('searchFormValues', { formValues });
  // };

  const isGeographicSearchEnabled = checkIfGeographicSearchEnabled(featureFlagSerpEnableGeographicSearch);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let taxAndCurrency;

  useEffect(() => {
    eventUtil.on('taxAndCurrencySessionUpdate', data => {
      taxAndCurrency = data;
    });
    return (): void => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      eventUtil.remove('taxAndCurrencySessionUpdate', () => {});
    };
  }, []);

  const getRooms = formValues?.roomsAndGuests?.roomsCount;

  const trackValue = isItForOffersPage
    ? `Body|Offer Search Button|internal`
    : `Storefront Properties List | Search Form Component - Find Hotels - Check In Date=${
        formValues?.dates?.fromDate?.toISOString().split('T')[0]
      }, Check Out Date=${formValues?.dates?.toDate?.toISOString().split('T')[0]}, Rooms=${
        formValues?.roomsAndGuests?.roomsCount
      }, Adults=${formValues?.roomsAndGuests?.adultsCount}, Children=${formValues?.roomsAndGuests?.childrenCount}, ${
        formValues?.roomsAndGuests?.childrenAges ? `Children age=${formValues?.roomsAndGuests?.childrenAges}, ` : ''
      }Special Rate=${
        formValues?.specialRates?.displayText
          ? formValues?.specialRates?.displayText
          : formValues?.specialRates?.clusterCode
      }, Use Points/Certificates=${formValues?.usePoints?.value ? 'Checked' : 'Unchecked'} | Internal`;

  // const findBtn = (): void => {
  //   if (isPublishUserSelection) {
  //     if (getRooms === '4-9') {
  //       eventUtil.dispatch('bannerMessage', { displayBanner: true });
  //       document.dispatchEvent(
  //         new CustomEvent('showBannerMessage', {
  //           detail: { displayBanner: true, bannerMessage: `${storefrontPropertySearchWidgetErrorMessageRooms}` },
  //         })
  //       );
  //     } else {
  //       eventUtil.dispatch('bannerMessage', { displayBanner: false });
  //       document.dispatchEvent(
  //         new CustomEvent('showBannerMessage', {
  //           detail: { displayBanner: false, bannerMessage: `${storefrontPropertySearchWidgetErrorMessageRooms}` },
  //         })
  //       );
  //     }
  //   }

  //   if (isPublishUserSelection && getRooms !== '10-25' && getRooms !== '26+') {
  //     eventDispatch();
  //   }
  // };

  const handleUpdateSearch = () => {
    if (isConcurFlowActive(featureFlags, sessionData) && userDetailsState?.isUserDetailsSaved) {
      const concurCode = extractConcurCode(userDetailsState);
      const currentSpecialRate = formValues?.specialRates?.clusterCode;
      const currentCorpCode = formValues?.specialRates?.corporateCode;

      // If user has changed from Concur code, set the override flag
      if (concurCode && concurCode !== 'none' && concurCode !== '') {
        const isStillUsingConcur = currentSpecialRate === 'corp' && currentCorpCode === concurCode;
        if (!isStillUsingConcur) {
          setConcurUserOverride();
        }
      }
    }

    setClicked(true);
  };
  const pageContext = useConditionalPageContextSERP();
  const sessionData = pageContext?.sessionData?.data
    ? pageContext?.sessionData?.data
    : pageContext?.sessionData?.cacheData?.data;

  //moved button onClick to this useEffect to wait for suggestedPlaceDetailsCallDone state update
  useEffect(() => {
    if (suggestedPlaceDetailsCallDone && clicked) {
      setClicked(false);

      setIsUserInteractWithComp(false);
      setIsUserEditSearchForm(false);
      setIsUpdateSearchClicked(true);
      SearchHandlerForUXLCAll(
        formValues,
        tabSelected === flexibleTabText,
        nightCount,
        isAutoSuggestSelected,
        isRecentSearchSelected,
        searchFormRef,
        NEXT_PUBLIC_PRE_PROCESSING_URL,
        sessionData,
        interceptorResponse,
        preHeader,
        pageContext?.currentLocale,
        pageContext?.headersData,
        localDateFormat,
        isGeographicSearchEnabled
      );
      updateRecentSearched(formValues);
    }
  }, [clicked, suggestedPlaceDetailsCallDone]);

  const handleADFSubmit = () => {
    // Track user override if they're changing special rates after Concur was applied
    if (
      isConcurFlowActive(featureFlags, pageContext?.sessionData?.data || pageContext?.sessionData?.cacheData?.data) &&
      userDetailsState?.isUserDetailsSaved
    ) {
      const concurCode = extractConcurCode(userDetailsState);
      const currentSpecialRate = formValues?.specialRates?.clusterCode;
      const currentCorpCode = formValues?.specialRates?.corporateCode;

      // If user has changed from Concur code, set the override flag
      if (concurCode && concurCode !== 'none' && concurCode !== '') {
        const isStillUsingConcur = currentSpecialRate === 'corp' && currentCorpCode === concurCode;
        if (!isStillUsingConcur) {
          setConcurUserOverride();
        }
      }
    }

    const flexible = tabSelected === flexibleTabText && isADFPage ? 'true' : 'false';
    const params = formFindHotelsQuery(
      searchFormRef,
      pageContext?.headersData,
      pageContext?.currentLocale,
      localDateFormat
    );
    setIsUpdateSearchClicked(true);
    eventUtil.dispatch('availabilityCalendarSearchFormData', {
      formValues,
      params,
      preHeader,
      flexible,
    });
  };
  return (
    <StyledFindBtn
      data-component-name="a-shop-FindBtn"
      data-testid="shop-FindBtn"
      className={clsx(
        'search-form-btn',
        'find-btn',
        'm-button-m',
        'm-button-secondary',
        'custom_click_track',
        isADFPage ? 'adf-update-search-btn' : ''
      )}
      type={
        (isPublishUserSelection || isSearchPage) && getRooms !== '10-25' && getRooms !== '26+' ? `button` : `submit`
      }
      data-analytics={isItForOffersPage ? "{'location':'offersSearchForm'}" : "{'location':'searchForm'}"}
      onClick={isADFPage ? handleADFSubmit : handleUpdateSearch}
      custom_click_track_value={
        isPublishUserSelection ? trackValue : `${getSearchFormClickTrackingLoc()}| Update Search Button |internal`
      }
    >
      <span
        className="custom_click_track"
        custom_click_track_value={
          isPublishUserSelection ? trackValue : `${getSearchFormClickTrackingLoc()}| Update Search Button |internal`
        }
      >
        {' '}
        {findHotelLabel as string}
      </span>
    </StyledFindBtn>
  );
};

export default FindBtn;
